// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back-button {\n  height: 35px !important;\n  width: 35px !important;\n  min-width: 35px !important;\n  padding: 0 !important;\n  opacity: 1;\n  align-self: flex-start;\n  margin-bottom: 4% !important;\n  margin-top: 4% !important;\n  margin-left: 4% !important;\n}", ""]);
// Exports
module.exports = exports;
